export type ProductLine = {
  id: string;
  stage: string;
  name: string;
  text: string;
  images: string[];
  note: string;
};

export const futureLines: ProductLine[] = [
  {
    id: "pattern",
    stage: "Next",
    name: "Pattern Collection",
    text: "A second crusher shape with minimal black, silver, and white graphics: Orbital, Circuit, Topo, Void, Prism, and 30+ more. Each design comes in tall and short versions.",
    images: [
      "https://cdn.magicpatterns.com/uploads/mfTySNBRHFwfGCPcWH2nX2/ChatGPT_Image_Sep_25,_2026,_10_32_27_AM_(2).png",
      "https://cdn.magicpatterns.com/uploads/rfBk6ZwgFtcyDZJyFyWW7F/ChatGPT_Image_Sep_25,_2026,_10_32_26_AM_(1).png",
    ],
    note: "Different mold and material, so it needs its own factory quote.",
  },
  {
    id: "baggies",
    stage: "Later",
    name: "Printed Baggies",
    text: "Resealable bags printed with a lettered and numbered grid, matching the Pattern Collection. They're a low-cost add-on that goes with every crusher.",
    images: ["https://cdn.magicpatterns.com/uploads/rojC38sxCTMoYK3ycCwUVV/ChatGPT_Image_Sep_25,_2026,_12_42_09_PM-2.png"],
    note: "Low minimums and high margin. Good for bundles.",
  },
];
